<template>
	<div class="graph-container">
    <donut-chart :chartData="dataToShow" :options="options" v-if="type === 'donut'"></donut-chart>
    <table-chart :chartData="dataToShow" :headers="selectedReport.headers" :name="selectedReport.title" :options="options" v-if="type === 'table'"></table-chart>
    <bar-chart :chartData="dataToShow" :options="options" :height="350" v-if="type === 'bar'"></bar-chart>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import BarChart from './BarChart'
import DonutChart from './DonutChart'
import TableChart from './TableChart'

export default {
  name: 'report',
  props: ['selectedReport', 'timeperiod', 'type', 'isAdvisor', 'adviseeName'],
  components: {
    BarChart,
    DonutChart,
    TableChart
  },
  data: () => {
    return {
      response: {},
      options: {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true,
              mirror: true
            }
          }],
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              mirror: true,
							padding: -15,
							fontColor: '#000',
							fontSize: 16,
							z: 1
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    this.loadReport()
  },
  methods: {
    ...mapActions([
      'loadReportQuery'
    ]),

    async loadReport () {
    },
    getRandomColorHex () {
      let hex = '0123456789ABCDEF'
      let color = '#'
      for (var i = 1; i <= 6; i++) {
        color += hex[Math.floor(Math.random() * 16)]
      }
      return color
    }
  },
  computed: {
    ...mapState({
    }),
    dataToShow () {
      let data = {

      }
      if (this.type === 'table') {
        data = JSON.parse(this.selectedReport.description)
      } else {
        data = {
          labels: [],
          datasets: [
            {
              label: '',
              data: [],
              barPercentage: 0.7,
              backgroundColor: [
                'rgba(22,143,207,0.8)',
  							'rgba(212,56,186,0.8)',
  							'rgba(20,118,28,0.7)',
  							'rgba(233,172,50,0.8)',
  							'rgba(214,182,250,0.9)',
  							'rgba(242,198,160,0.8)',
  							'rgba(255,160,129,0.8)',
  							'rgba(171,208,245,0.8)',
  							'rgba(237,229,154,0.8)',
  							'rgba(173,247,247,0.8)'
              ]
            }
          ]
        }
        if (this.timeperiod === '7') {
          this.selectedReport.data7.forEach((item, i) => {
            if (i < 22) {
              if (this.isAdvisor && item['key'] === 'Me') {
                if (this.adviseeName) {
                  data.labels.push(this.adviseeName)
                } else {
                  data.labels.push('Student')
                }
              } else if (this.isAdvisor && item['key'] === 'Average (My Program)') {
                if (this.adviseeName) {
                  data.labels.push("Average (" + this.adviseeName + "'s Program)")
                } else {
                  data.labels.push("Average (Student's Program)")
                }
              } else if (this.isAdvisor && item['key'] === 'Average (My Institution)') {
                if (this.adviseeName) {
                  data.labels.push("Average (" + this.adviseeName + "'s Institution)")
                } else {
                  data.labels.push("Average (Student's Institution)")
                }
              } else {
                data.labels.push(item['key'])
              }
              data.datasets[0].data.push(item['doc_count'])
              data.datasets[0].backgroundColor.push(this.getRandomColorHex())
            }
          })
        } else if (this.timeperiod === '30') {
          this.selectedReport.data30.forEach((item, i) => {
            if (i < 22) {
              if (this.isAdvisor && item['key'] === 'Me') {
                if (this.adviseeName) {
                  data.labels.push(this.adviseeName)
                } else {
                  data.labels.push('Student')
                }
              } else if (this.isAdvisor && item['key'] === 'Average (My Program)') {
                if (this.adviseeName) {
                  data.labels.push("Average (" + this.adviseeName + "'s Program)")
                } else {
                  data.labels.push("Average (Student's Program)")
                }
              } else if (this.isAdvisor && item['key'] === 'Average (My Institution)') {
                if (this.adviseeName) {
                  data.labels.push("Average (" + this.adviseeName + "'s Institution)")
                } else {
                  data.labels.push("Average (Student's Institution)")
                }
              } else {
                data.labels.push(item['key'])
              }
              data.datasets[0].data.push(item['doc_count'])
              data.datasets[0].backgroundColor.push(this.getRandomColorHex())
            }
          })
        } else if (this.timeperiod === '60') {
          this.selectedReport.data60.forEach((item, i) => {
            if (i < 22) {
              if (this.isAdvisor && item['key'] === 'Me') {
                if (this.adviseeName) {
                  data.labels.push(this.adviseeName)
                } else {
                  data.labels.push('Student')
                }
              } else if (this.isAdvisor && item['key'] === 'Average (My Program)') {
                if (this.adviseeName) {
                  data.labels.push("Average (" + this.adviseeName + "'s Program)")
                } else {
                  data.labels.push("Average (Student's Program)")
                }
              } else if (this.isAdvisor && item['key'] === 'Average (My Institution)') {
                if (this.adviseeName) {
                  data.labels.push("Average (" + this.adviseeName + "'s Institution)")
                } else {
                  data.labels.push("Average (Student's Institution)")
                }
              } else {
                data.labels.push(item['key'])
              }
              data.datasets[0].data.push(item['doc_count'])
              data.datasets[0].backgroundColor.push(this.getRandomColorHex())
            }
          })
        } else {
          this.selectedReport.data.forEach((item, i) => {
            if (i < 22) {
              if (this.isAdvisor && item['key'] === 'Me') {
                if (this.adviseeName) {
                  data.labels.push(this.adviseeName)
                } else {
                  data.labels.push('Student')
                }
              } else if (this.isAdvisor && item['key'] === 'Average (My Program)') {
                if (this.adviseeName) {
                  data.labels.push("Average (" + this.adviseeName + "'s Program)")
                } else {
                  data.labels.push("Average (Student's Program)")
                }
              } else if (this.isAdvisor && item['key'] === 'Average (My Institution)') {
                if (this.adviseeName) {
                  data.labels.push("Average (" + this.adviseeName + "'s Institution)")
                } else {
                  data.labels.push("Average (Student's Institution)")
                }
              } else {
                data.labels.push(item['key'])
              }
              data.datasets[0].data.push(item['doc_count'])
              data.datasets[0].backgroundColor.push(this.getRandomColorHex())
            }
          })
        }
      }
      return data
    }

  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/institution/components/Report.vue